var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirsticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.49 29.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#016846",
    strokeMiterlimit: 10,
    d: "M23.99,5.83v10.86c0,1.79-.6,3.52-1.7,4.94-1.75,2.24-4.92,5.48-9.83,7.61-.17.08-.38.08-.55,0-4.91-2.13-8.04-5.37-9.76-7.62-1.07-1.4-1.65-3.12-1.65-4.88V5.83c0-.37.3-.65.66-.66,4.66-.11,9.33-3.47,10.69-4.54.24-.18.56-.18.79,0,1.36,1.06,6.03,4.43,10.68,4.54.37,0,.66.29.66.66Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#016846",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    points: "6.59 13.89 10.72 18.02 18.62 10.12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirsticon);
export default __webpack_public_path__ + "static/media/firsticon.d4d4de44c72067981a56a46eacffb886.svg";
export { ForwardRef as ReactComponent };